import { Observable } from 'rxjs/Observable';
import { StoreFacade } from '../../../core/store/facade/store-facade';
import * as actions from './config.actions';
import { ConfigQueries } from './config.queries';

export class ConfigStoreFacade extends StoreFacade {

    setAuthToken(value: any): void {
        this.dispatch(new actions.SetAuthTokenAction(value));
    }

    getAuthToken(): Observable<string> {
        return this.select(ConfigQueries.getAuthToken);
    }

    setLastSyncDownDate(accountId: string, date: string): void {
        this.dispatch(new actions.SetLastSyncDownAction({
            accountId,
            date
        }));
    }

    getLastSyncDownDate(accountId: string): Observable<string> {
        return this.select(ConfigQueries.getLastSyncDownDate)
            .map(datesByAccount => datesByAccount[accountId]);
    }

    clearLastSyncDownDates(): void {
        this.dispatch(new actions.ClearLastSyncDownDates());
    }

    setRefreshToken(value: any): void {
        this.dispatch(new actions.SetRefreshTokenAction(value));
    }

    getRefreshToken(): Observable<string> {
        return this.select(ConfigQueries.getRefreshToken);
    }

    setRestEndpoint(value: any): void {
        this.dispatch(new actions.SetRestEndpointAction(value));
    }

    updateRestEndpoint(value: any): void {
        this.dispatch(new actions.UpdateRestEndpointAction(value));
    }

    getRestEndpoint(): Observable<string> {
        return this.select(ConfigQueries.getRestEndpoint);
    }

    setRestHost(value: any): void {
        this.dispatch(new actions.SetRestHostAction(value));
    }

    updateRestHost(value: any): void {
        this.dispatch(new actions.UpdateRestHostAction(value));
    }

    getRestHost(): Observable<string> {
        return this.select(ConfigQueries.getRestHost);
    }

    updateRestHostAndEndpointAction(host: string, endpoint: string): void {
        this.dispatch(new actions.UpdateRestHostAndEndpointAction({
            host, endpoint
        }));
    }
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/config/config.store-facade.ts